<template>
  <div class="saved" />
</template>

<script>
export default {
  name: 'SavedView'
};
</script>

<style scoped>
  .saved {
    width: 60%;
    height: 90%;
    background-color: white;
  }
</style>